function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 274.5,
  cy: 274.5,
  r: 224.5,
  fill: "#FAF9F7",
  stroke: "#119C59",
  strokeWidth: 100
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M477.375 265.75H481.625H515.625",
  stroke: "#FAF9F7",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M488 265.75V261.5C488 260.373 488.448 259.292 489.245 258.495C490.042 257.698 491.123 257.25 492.25 257.25H500.75C501.877 257.25 502.958 257.698 503.755 258.495C504.552 259.292 505 260.373 505 261.5V265.75M511.375 265.75V295.5C511.375 296.627 510.927 297.708 510.13 298.505C509.333 299.302 508.252 299.75 507.125 299.75H485.875C484.748 299.75 483.667 299.302 482.87 298.505C482.073 297.708 481.625 296.627 481.625 295.5V265.75H511.375Z",
  stroke: "#FAF9F7",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M492.25 276.375V289.125",
  stroke: "#FAF9F7",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M500.75 276.375V289.125",
  stroke: "#FAF9F7",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M295.833 30.3752C296.402 29.817 297.078 29.3743 297.821 29.0723C298.565 28.7702 299.362 28.6147 300.167 28.6147C300.971 28.6147 301.768 28.7702 302.512 29.0723C303.255 29.3743 303.931 29.817 304.5 30.3752C305.069 30.9333 305.52 31.5959 305.828 32.3251C306.136 33.0543 306.295 33.8359 306.295 34.6252C306.295 35.4145 306.136 36.196 305.828 36.9252C305.52 37.6545 305.069 38.317 304.5 38.8752L275.25 67.5627L263.333 70.7502L266.583 59.0627L295.833 30.3752Z",
  stroke: "#FAF9F7",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M74.3333 126.375H87.3333C89.6318 126.375 91.8362 127.271 93.4615 128.865C95.0868 130.459 95.9999 132.621 95.9999 134.875V164.625C95.9999 162.934 95.3151 161.313 94.0961 160.117C92.8771 158.922 91.2238 158.25 89.4999 158.25H74.3333V126.375Z",
  stroke: "#FAF9F7",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M117.667 126.375H104.667C102.368 126.375 100.164 127.271 98.5384 128.865C96.9131 130.459 96 132.621 96 134.875V164.625C96 162.934 96.6848 161.313 97.9038 160.117C99.1228 158.922 100.776 158.25 102.5 158.25H117.667V126.375Z",
  stroke: "#FAF9F7",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M427.167 428.5C427.167 428.5 435.833 411.5 451 411.5C466.167 411.5 474.833 428.5 474.833 428.5C474.833 428.5 466.167 445.5 451 445.5C435.833 445.5 427.167 428.5 427.167 428.5Z",
  stroke: "#FAF9F7",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M451 434.875C454.59 434.875 457.5 432.021 457.5 428.5C457.5 424.979 454.59 422.125 451 422.125C447.41 422.125 444.5 424.979 444.5 428.5C444.5 432.021 447.41 434.875 451 434.875Z",
  stroke: "#FAF9F7",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M300.167 519.625L285 509L269.833 519.625V485.625C269.833 484.498 270.29 483.417 271.102 482.62C271.915 481.823 273.017 481.375 274.167 481.375H295.833C296.983 481.375 298.085 481.823 298.897 482.62C299.71 483.417 300.167 484.498 300.167 485.625V519.625Z",
  stroke: "#FAF9F7",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M119.81 426.807C123.357 426.807 126.232 423.932 126.232 420.386C126.232 416.84 123.357 413.965 119.81 413.965C116.264 413.965 113.389 416.84 113.389 420.386C113.389 423.932 116.264 426.807 119.81 426.807Z",
  stroke: "#FAF9F7",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M94.1264 441.789C97.6726 441.789 100.547 438.915 100.547 435.368C100.547 431.822 97.6726 428.947 94.1264 428.947C90.5801 428.947 87.7053 431.822 87.7053 435.368C87.7053 438.915 90.5801 441.789 94.1264 441.789Z",
  stroke: "#FAF9F7",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M119.81 456.772C123.357 456.772 126.232 453.897 126.232 450.351C126.232 446.804 123.357 443.93 119.81 443.93C116.264 443.93 113.389 446.804 113.389 450.351C113.389 453.897 116.264 456.772 119.81 456.772Z",
  stroke: "#FAF9F7",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M99.6697 438.6L114.288 447.119",
  stroke: "#FAF9F7",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M114.267 423.618L99.6697 432.136",
  stroke: "#FAF9F7",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M70.625 299.5C70.625 300.649 70.1772 301.751 69.3802 302.564C68.5832 303.377 67.5022 303.833 66.375 303.833H40.875L32.375 312.5V277.833C32.375 276.684 32.8228 275.582 33.6198 274.769C34.4168 273.957 35.4978 273.5 36.625 273.5H66.375C67.5022 273.5 68.5832 273.957 69.3802 274.769C70.1772 275.582 70.625 276.684 70.625 277.833V299.5Z",
  stroke: "#FAF9F7",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M271.745 240C253.418 241.457 239 256.791 239 275.492C239 295.157 254.941 311.098 274.606 311.098C289.788 311.098 302.751 301.595 307.871 288.213H271.745V240ZM310.153 277.537C310.192 276.861 310.211 276.179 310.211 275.492C310.211 259.403 299.54 245.807 284.889 241.394V277.537H310.153Z",
  fill: "#119C59"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M284.567 277.76V240.083C284.567 240.083 298.089 244.167 305.195 256.215C312.3 268.264 310.885 277.76 310.885 277.76H284.567Z",
  fill: "#25282B"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M462 124.25L468.695 137.553L483.667 139.699L472.833 150.048L475.39 164.668L462 157.761L448.61 164.668L451.167 150.048L440.333 139.699L455.305 137.553L462 124.25Z",
  stroke: "#FAF9F7",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgPersonalizeImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 549,
    height: 549,
    viewBox: "0 0 549 549",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalizeImage);
export default __webpack_public_path__ + "static/media/PersonalizeImage.a217e52e.svg";
export { ForwardRef as ReactComponent };